import React from 'react';

const ErrorHeader = props => {
	return (
		<header className="header-flex-container header-default">
			<div className="header-flex-left">				
				<div className="header-item logo error-header-logo" onClick={props.navigateHome}>
					&nbsp;
					<span className="hidden">iMemories&reg;</span>
				</div>
			</div>
			<div className="header-flex-right">
				<div className="header-flex-spacer" />
			</div>
		</header>
	);
};

export default ErrorHeader;


// WEBPACK FOOTER //
// ./src/header/components/error-header.jsx